var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-res"},[_c('div',{staticClass:"btn"},[_c('div',{on:{"click":_vm.bindDownload}},[_vm._v("下载 betterWE星球APP")])])])}
var staticRenderFns = []

export { render, staticRenderFns }